import { render, staticRenderFns } from "./allCategoriesUnit.vue?vue&type=template&id=4b50259e&scoped=true"
import script from "./allCategoriesUnit.vue?vue&type=script&lang=js"
export * from "./allCategoriesUnit.vue?vue&type=script&lang=js"
import style0 from "./allCategoriesUnit.vue?vue&type=style&index=0&id=4b50259e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50259e",
  null
  
)

export default component.exports